var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "resource-tags" },
    [
      _vm._l(_vm.displayResources, function (resource) {
        return _c(
          "v-chip",
          {
            key: resource.id,
            staticClass: "mr-1 mb-1",
            attrs: {
              color: _vm.getChipColor(resource),
              outlined: _vm.outlined,
              small: _vm.small,
              "x-small": _vm.xSmall,
            },
          },
          [
            _c(
              "v-icon",
              {
                attrs: {
                  left: !_vm.iconOnly,
                  small: _vm.small || _vm.xSmall,
                  "x-small": _vm.xSmall,
                },
              },
              [_vm._v(" " + _vm._s(_vm.getResourceIcon(resource)) + " ")]
            ),
            !_vm.iconOnly
              ? _c("span", [
                  _vm._v(_vm._s(resource.name || resource.resource?.name)),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      _vm.hasMoreResources && !_vm.showAll
        ? _c(
            "v-chip",
            {
              staticClass: "mr-1 mb-1",
              attrs: { small: "", outlined: "", color: "grey" },
              on: {
                click: function ($event) {
                  return _vm.$emit("show-all")
                },
              },
            },
            [_vm._v(" +" + _vm._s(_vm.resources.length - _vm.maxDisplay) + " ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }